// eslint-disable-next-line valid-jsdoc
/**
 * Flatten a multidimensional object
 * Code found here: https://stackoverflow.com/questions/54896928/flattening-the-nested-object-in-javascript
 *
 * For example:
 *   flattenObject({ a: 1, b: { c: 2 } })
 * Returns:
 *   { 'a': 1, 'b.c' : 2}
 */

 type EmptyObject = Partial<Record<string, never>>
type SimplifiedObject = Record<string | symbol | number, unknown>

export const flattenObject = (obj: SimplifiedObject | EmptyObject, prefix = '', res: SimplifiedObject = {}) =>
  Object.entries(obj).reduce((r, [key, val]) => {
    const k = `${prefix}${key}`;
    if (typeof val === 'object' && val !== null) {
      flattenObject(val, `${k}.`, r);
    } else {
      res[k] = val;
    }
    return r;
  }, res);

export const sortAlphabetically = (a: {name?: string}, b: {name?: string}) => {
  if (!a.name || !b.name) {
    return 0;
  }

  const nameA = a.name.toUpperCase(); // ignore upper and lowercase
  const nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
};
